export const uk = {
    'error-refresh': 'Возникла ошибка. Попробуйте обновить страницу.'
};
